const axios = require('axios')
import getCookie from '@/service/getCookie'
import deleteCookie from '@/service/deleteCookie'
import store from '../desktop/stores' 
import { commonMixin } from '../mixins/common'

var needLoadingRequestCount = 0;
const axiosWrap = async (method, url, data = null, resType = null, debugMsg = '', x_api_host = 'mycrm', sys = 'MX') => {
  let option = {
    'Content-Type': 'text/plain',
    'x-api-host': x_api_host,
  }
  
  let x_api_key = getCookie('api-keys') ? JSON.parse(getCookie('api-keys'))[0] : '';
  if (x_api_key) {
    option['x-api-key'] = x_api_key
  }
		  
  const click = window.event && window.event.type && 'click' == window.event.type;
  let target;
  let parent;
  let node;
  // 若是點擊觸發，將按鈕改成無法二次點選，待API呼叫完後復原
  if (click) {
    target = window.event.target;
    node = $(target)[0].nodeName;
    parent = $(target)[0].parentNode;
    if ($(parent)[0].nodeName == 'BUTTON') {
      $(parent).attr('disabled', true);
      $(parent).css('cursor', 'not-allowed');
    } else if (node == 'BUTTON') {
      $(target).attr('disabled', true);
      $(target).css('cursor', 'not-allowed');
    } else {
      $(target).css('pointer-events', 'none');
    }
  }  
  /* 20250808配合滲透測試弱點移除header中x-id
  if (data && data.header && data.header.userId) {
    option['x-id'] = data.header.userId
  }
  */
  // 紀錄當前網址
  const nowHref = window.location.href

  // 判斷 API URL 前綴
  let BFF_API_BASEURL = window.location.origin;
  let API_BASEURL = `http://localhost:8081/${sys}Web`
  if(nowHref.indexOf('localhost') !== -1){
    API_BASEURL = `http://localhost:8081/${sys}Web`
    BFF_API_BASEURL = `http://localhost:8088`
  }else if(nowHref.indexOf('tmycrm') !== -1){
    API_BASEURL = `https://tcrmapi.cathaylife.com.tw/${sys}Web`
  }else if(nowHref.indexOf('smycrm') !== -1){
    API_BASEURL = `https://scrmapi.cathaylife.com.tw/${sys}Web`
  }else if(nowHref.indexOf('mycrm') !== -1){
    API_BASEURL = `https://crmapi.cathaylife.com.tw/${sys}Web`
  }else{
    API_BASEURL = `http://${nowHref.match(/\d*\.\d*\.\d*\.\d*/g)}:8081/${sys}Web`
  }
  let apiUrl = `${API_BASEURL}${url}`;
  let isLoggedIn = url.includes('isLoggedIn');
  let isBffLoginEnabled = url.includes('isBffLoginEnabled');
  if((sys === 'MX' && store.getters.IsBFF_MX) || (sys === 'MV' && store.getters.IsBFF_MV) || isLoggedIn || isBffLoginEnabled){ //isLoggedIn 判斷BFF是否登入
    apiUrl = `${BFF_API_BASEURL}/mid-mxf0-crm-ui${commonMixin.methods.convertUri(url)}`
    option['Content-Type'] = 'application/json';
    
    // 若 apiUrl 包含以下文字，強制改回 text/plain (WAF問題)
    // MXM01001/sortByName 客戶列表姓名排序
    // MXB11008/process、MXB11008/process2 服務件調撥/區部調撥/智能配對
    if (apiUrl.includes('MXM01001/sortByName') || 
        apiUrl.includes('MXB11008/process') || 
        apiUrl.includes('MXB11008/process2')) {
      option['Content-Type'] = 'text/plain';
    }

    delete option['x-api-key'];
  }
  

  // 設定逾時時間

  let timeOutSet = 60000
  if(isLoggedIn || isBffLoginEnabled){ // 判斷BFF是否登入
    timeOutSet = 3000; // BFF專案檢查是否登入，逾時時間設短一點
  }

  // 判斷是否為服務件調撥，如果是 timeout 延長為 3min
  let matchManager = nowHref.includes('manager')
  let notTransfer = nowHref.match(/BulletinBoard|condition|authorize/ig) == null // 確認不是佈告欄&條件篩選&授權管理
  let matchPrintPDF = nowHref.includes('policyHealthCheck')
  let matchFamilyRelation = nowHref.includes('familyRelation')

  // 如果是服務件調撥逾時設定成15mins
  if(matchManager && notTransfer) {timeOutSet = 60000 * 15}
  if(matchPrintPDF) {timeOutSet = 60000 * 30}
  if(matchFamilyRelation) {timeOutSet = 60000 * 15}
  //若為呼叫報表比對批次，一樣將逾時設定成15mins
  if(url.includes('getPDFcomparedResult')) {timeOutSet = 60000 * 15}

  // debug message log
  console.log(`Sent[${debugMsg}]Req:${method},url:${apiUrl}`)
  console.log(data)
  
  if (getCookie('api-keys') || isLoggedIn || isBffLoginEnabled) {   // 如果 api-key 沒有時不送出 Ajax
    return new Promise((resolve) => {
      // 舊有coverPage邏輯註解，修改成disalbe點選
      // showFullScreenLoading();
      axios({
        method: method,
        // url: `${API_PROXY}${API_BASEURL}${url}`,
        url: apiUrl,
        params: method === 'get' ? data : null,
        data: method === 'get' ? null : data,
        headers: option,
        responseType: resType,
        timeout: timeOutSet,
        withCredentials: true,
      })
      .then(response => {
        // tryHideFullScreenLoading();
        console.log(`Got[${debugMsg}]Res:${apiUrl}`)
        console.log(response)
        if (response.data && response.data.detail && (response.data.detail.loginUrl || response.data.detail.ssoUrl)) {
          // 後端回傳登入頁
          localStorage.forcePkmslogout = true;
          deleteCookie('api-keys')
        window.location.reload();
          return;
        }
        //20210422新增 ArrayBuffer回傳status判斷
        if ((response.data.header && (response.data.header.status == 200 || response.data.header.status == 0)) 
        || (response.headers['content-type'].includes('application/pdf') 
        || response.headers['content-type'].includes('text/html') 
        || response.headers['content-type'].includes('image/png') 
        || response.headers['content-type'].includes('image/jpeg') 
        || response.headers['content-type'].includes('application/octet-stream')
        || response.headers['content-type'].includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'))) {
          // return nothing
        }else if (response.data.header && response.data.header.status == 400) {
          console.error(`${debugMsg}異常: `, response.data.header ? response.data.header.message : '')
        } else {
          console.error(`${debugMsg}連線錯誤`)
        }
        resolve(response.data);
      })
      .catch(error => {
        // tryHideFullScreenLoading();
        console.error(`Got[${debugMsg}]Res:${apiUrl}`)
        console.error(error);
        if(isLoggedIn){//未登入
          resolve(false); // 回傳 false
          return;
        }
        // BFF 模式下登出後 302 被 CORS 阻擋，error.response 為 null (Network Error)
        const isBffMode = (sys === 'MX' && store.getters.IsBFF_MX) || (sys === 'MV' && store.getters.IsBFF_MV);
        if (isBffMode && !error.response && !apiUrl.includes('/logout')) {
          const redirectUrl = error.request && error.request.responseURL;
          if (redirectUrl && redirectUrl !== apiUrl) {
            window.location.href = redirectUrl;
          } else {
            window.location.reload(); // fallback：重新載入觸發登入檢查
          }
          return;
        }
        let errorData = {
          header:{
            message: "連線逾時 請重新操作",
            status: "400",
            userDeviceIp: "",
            userId: "",
          },
          body:{},
        }
        resolve(errorData);
        // reject(error);
      })
      .finally(() => {
        if (click) {
          if ($(parent)[0].nodeName == 'BUTTON') {
            $(parent).attr('disabled', false);
            $(parent).css('cursor', 'pointer');
          } else if (node == 'BUTTON') {
            $(target).attr('disabled', false);
            $(target).css('cursor', 'pointer');
          } else {
            $(target).css('pointer-events', '');
          }
        }
      });
    })
  } else {
    return new Promise((resolve) => {
      console.error(`${debugMsg}:api key 失效 Ajax 不傳送`)
      const errorData = {
        // body: {},
        // header: {
        //   // message: "api key 失效 Ajax 不傳送",
        //   status: "400",
        //   userDeviceIp: "",
        //   userId: "",
        // }
      }
      resolve(errorData)
    })
  }
  
}

function showFullScreenLoading() {
  const axiosCoverPage = $('#axiosCoverPage');
  if (!axiosCoverPage) return;
  if (needLoadingRequestCount === 0) {
    axiosCoverPage.css("display", "block");
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  const axiosCoverPage = $('#axiosCoverPage');
  if (!axiosCoverPage) return;
  if (needLoadingRequestCount <= 0) return;

  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    setTimeout(function() {
      axiosCoverPage.css("display", "none");
    }, 500);
  }
}


export default axiosWrap;